import * as React from "react";
import { Container, Stack } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Title, ContentHeader, ViewsContainer } from "../ui/BaseComponents";
import DataCard from "../ui/card/DataCard";
import {
  GraphUp,
  Tools,
  ExclamationCircleFill,
  PersonCheckFill,
  CarFrontFill,
} from "react-bootstrap-icons";
import ServiceRequestsTable from "../ui/table/ServiceRequestsTable";

export default function ViewDashboard() {
  return (
    <Container fluid>
      <Title>{"Dashboard Page"}</Title>
      <Stack>
        <ContentHeader>{"Dashboard"}</ContentHeader>
        <Row className='justify-content-md-center'>
          {/* <Col lg='4'></Col>
          <Col lg='4'>
            <DataCard
              icon={<ExclamationCircleFill />}
              title='Pending Providers'
              color='primary'
              endpoint={
                "https://ea1-dev.azurewebsites.net/api/userServiceProviderApprovals?approved=false"
              }
              path='/approvals'
              details={"See Pending Providers"}
              description={"that are awaiting approval"}
            />
          </Col>
          <Col lg='4'>{ <ServiceRequestsTable /> }</Col> */}
          <Col
            xs
            lg='12'
            style={{
              margin: "3em",
            }}
          >
            <h5 style={{ marginBottom: ".75em" }}>Analytics Overview</h5>
            <Row>
              <Col lg='3'>
                <DataCard
                  icon={<ExclamationCircleFill />}
                  title='Pending Providers'
                  color='primary'
                  endpoint={
                    "https://ea1-dev.azurewebsites.net/api/userServiceProviderApprovals?approved=false"
                  }
                  path='/approvals'
                  details={"See Pending Providers"}
                  description={"that are awaiting approval"}
                />
              </Col>
              <Col lg='3'>
                <DataCard
                  icon={<PersonCheckFill />}
                  title='Approved Service Providers'
                  color='success'
                  endpoint={
                    "https://ea1-dev.azurewebsites.net/api/userServiceProviderApprovals?approved=true"
                  }
                  path='/providers'
                  details={"See Service Providers"}
                  description={"that are currently active"}
                />
              </Col>
              <Col lg='3'>
                <DataCard
                  icon={<CarFrontFill />}
                  title='Service Requesters'
                  color='danger'
                  endpoint={
                    "https://ea1-dev.azurewebsites.net/api/userServiceRequesterBasic"
                  }
                  path='/requestors'
                  details={"See Service Requesters"}
                  description={"that are currently active"}
                />
              </Col>
              <Col lg='3'>
                <DataCard
                  icon={<Tools />}
                  title='Service Types'
                  color='warning'
                  endpoint={"https://ea1-dev.azurewebsites.net/api/serviceType"}
                  path='/services'
                  details={"See Service Types"}
                  description={"that are currently provided"}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Stack>
    </Container>
  );
}
